




















import Vue from "vue";

import Block from "@miele/component-library-vue/src/components/content/layouts/Block.vue";
import RecipeTile from "@/components/RecipeTile.vue";
import LayoutTileGrid from "@miele/component-library-vue/src/components/layouts/LayoutTileGrid.vue";

export default Vue.extend({
  name: "ResultsList",
  components: {
    RecipeTile,
    LayoutTileGrid,
    Block,
  },
  props: {
    noResultsCopy: {
      type: String,
      required: true,
    },
    recipes: {
      type: Array,
      required: true,
    },
    columns: {
      type: Number,
      required: true,
    },
  },
});
